import { render, staticRenderFns } from "./CommonStatusBadge.vue?vue&type=template&id=441f1612&scoped=true&"
import script from "./CommonStatusBadge.vue?vue&type=script&lang=js&"
export * from "./CommonStatusBadge.vue?vue&type=script&lang=js&"
import style0 from "./CommonStatusBadge.vue?vue&type=style&index=0&id=441f1612&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "441f1612",
  null
  
)

export default component.exports